import React from "react";
import PropTypes from "prop-types";

import { styled, useTheme } from "@mui/material/styles";

import Typography from "ui/Typography";

function DialogHeader(props) {
  const { title, subTitle, Icon, headerIconSize = "24px" } = props;
  const { palette } = useTheme();
  const hasIcon = !!Icon;

  const renderTitle = () => (
    <TitleContainer hasIcon={hasIcon}>
      {hasIcon && (
        <Icon width={headerIconSize} color={palette.surface.surfaceVariant} />
      )}
      {title && <Typography variant="h5">{title}</Typography>}
      {subTitle && (
        <Typography variant="body1" align={hasIcon ? "center" : "left"}>
          {subTitle}
        </Typography>
      )}
    </TitleContainer>
  );

  return <HeaderContainer>{renderTitle()}</HeaderContainer>;
}

const HeaderContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  alignSelf: "stretch",
  wordBreak: "break-word",
  overflowWrap: "break-word",
  wordWrap: "break-word",
}));

const TitleContainer = styled("div")(({ hasIcon }) => {
  const padding = "24px 24px 0px 24px";
  const alignItems = hasIcon ? "center" : "flex-start";
  const gap = hasIcon ? "16px" : "2px";
  return {
    padding,
    alignItems,
    gap,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignSelf: "stretch",
  };
});

export const DialogHeaderPropTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  hasChildren: PropTypes.bool,
  Icon: PropTypes.any,
  headerIconSize: PropTypes.string,
};

DialogHeader.propTypes = DialogHeaderPropTypes;

export default DialogHeader;
